import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import EmberTooltip from '@mylighthouse/prism-ember/components/ember-tooltip';
import type { Dayjs } from 'dayjs';
import { t } from 'ember-intl';

import styles from './pricing-assistant-table-tooltip.module.css';

interface HotelPricingAssistantTableTooltipsTooltipRoomLeftToSellSignature {
  Args: {
    date: Dayjs;
    leftToSell: number;
    overbooking: number;
    roomName: string;
  };
}

export default class HotelPricingAssistantTableTooltipsTooltipRoomLeftToSell extends Component<HotelPricingAssistantTableTooltipsTooltipRoomLeftToSellSignature> {
  @service declare dates: Services['dates'];

  get formattedDate(): string {
    return this.args.date.format(
      this.dates.partialDateFormat.WEEKDAY_AND_DATE_LONG,
    );
  }

  <template>
    <EmberTooltip
      @side="bottom"
      @tooltipClass="base-tooltip {{styles.container}}"
    >
      <div class="{{styles.header}} flex items-center p-400">
        <h4>
          {{this.formattedDate}}
        </h4>
      </div>
      <div>
        <table class="default-table {{styles.table}}">
          <tbody>
            <tr>
              <td class="{{styles.table-row-cell}} text-200--regular">
                <p class="text-200--bold">{{t "pricing_manager.room"}}</p>
                <p class="text-200--regular text-right text-wrap">
                  {{@roomName}}
                </p>
              </td>
            </tr>
            <tr>
              <td class="{{styles.table-row-cell}} text-200--regular">
                <p class="text-200--bold">
                  {{t
                    "pricing_manager.monthly_table.left_to_sell_incl_overbooking"
                    overbooking=@overbooking
                  }}
                </p>
                <p>{{@leftToSell}}</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </EmberTooltip>
  </template>
}
